import propTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import * as style from './style.module.css';

const Counter = ({ count = 0 }) => {
    return (
        <div className={style.counter}>
            <div className={style.content}>{count}</div>
        </div>
    );
};

Counter.propTypes = {
    count: propTypes.number,
};

export default withTranslation()(Counter);
